import { FC } from "react";
import { NotApplicableIcon } from "./NotApplicableIcon";
import { PendingIcon } from "./PendingIcon";
import { Cancel, CheckCircle } from "@material-ui/icons";
import { AnswerOT } from "src/models/OT/Sheet";
import { BlockedIcon } from "./BlockedIcon";
import { Box } from "@material-ui/core";

export const ResponseIcon: FC<AnswerOT> = ({ Estado, Foto }) => {
	// Log para depurar falsos positivos en aprobaciones
	console.log(`[ResponseIcon] Estado recibido: "${Estado}" - ${Estado === "Aprobado" ? "✅ APROBADO" : "❌ NO APROBADO"}`);

	const hasImage = !!Foto;
	
	// Alert temporal para confirmar ubicación
	if (hasImage) {
		console.log("ResponseIcon: Imagen detectada - aplicando borde verde");
	}
	
	const iconStyle = hasImage ? {
		border: '2px solid rgb(50, 205, 50)',
		borderRadius: '20px',
		padding: '0px',
		display: 'flex'
	} : {};

	const renderIcon = () => {
		switch (Estado) {
			case "Aprobado":
				console.log(`[ResponseIcon] Renderizando ícono verde para estado APROBADO`);
				return <CheckCircle htmlColor="limegreen" />;
			case "Rechazado":
				console.log(`[ResponseIcon] Renderizando ícono rojo para estado RECHAZADO`);
				return <Cancel htmlColor="firebrick" />;
			case "No Aplica":
				console.log(`[ResponseIcon] Renderizando ícono azul para estado NO APLICA`);
				return <NotApplicableIcon />;
			case "Bloqueado":
				console.log(`[ResponseIcon] Renderizando ícono dorado para estado BLOQUEADO`);
				return <BlockedIcon />;
			default:
				console.log(`[ResponseIcon] Renderizando ícono púrpura para estado PENDIENTE/DEFAULT: "${Estado}"`);
				return <PendingIcon />;
		}
	};

	return (
		<Box style={iconStyle}>
			{renderIcon()}
		</Box>
	);
};
